module.exports = __webpack_public_path__ + "img/2f_r_bajitofu.ba62fef2.jpg";